
(function() {
  'use strict';

  function initDescriptionToggle() {
    const containers = document.querySelectorAll('[data-description-container]');
    
    containers.forEach(container => {
      const descText = container.querySelector('[data-description-text]');
      const toggleBtn = container.querySelector('[data-description-toggle]');
      const textShow = toggleBtn?.querySelector('[data-text-show]');
      const textHide = toggleBtn?.querySelector('[data-text-hide]');
      
      if (!descText || !toggleBtn) return;

      let isExpanded = false;

      function checkIfNeedsToggle() {
        
        descText.style.maxHeight = 'none';
        descText.style.webkitLineClamp = 'none';
        descText.style.overflow = 'visible';
        descText.style.display = 'block';
        
        const fullHeight = descText.scrollHeight;
        const lineHeight = parseFloat(window.getComputedStyle(descText).lineHeight) || 24;
        const threeLinesHeight = lineHeight * 3;

        if (fullHeight > threeLinesHeight) {
          toggleBtn.classList.remove('hidden');
          // Estado inicial: fechado
          toggleBtn.classList.add('is-closed');
          toggleBtn.classList.remove('is-open');
          
          descText.style.maxHeight = threeLinesHeight + 'px';
          descText.style.overflow = 'hidden';
          descText.style.display = '-webkit-box';
          descText.style.webkitLineClamp = '3';
          descText.style.webkitBoxOrient = 'vertical';
        } else {
          toggleBtn.classList.add('hidden');
          descText.style.maxHeight = 'none';
          descText.style.overflow = 'visible';
          descText.style.display = 'block';
        }
      }

      function toggleDescription() {
        isExpanded = !isExpanded;
        
        if (isExpanded) {
          // Adiciona classe quando aberto
          toggleBtn.classList.add('is-open');
          toggleBtn.classList.remove('is-closed');
          
          descText.style.maxHeight = 'none';
          descText.style.overflow = 'visible';
          descText.style.display = 'block';
          descText.style.webkitLineClamp = 'none';
          if (textShow) textShow.classList.add('hidden');
          if (textHide) textHide.classList.remove('hidden');
        } else {
          // Adiciona classe quando fechado
          toggleBtn.classList.add('is-closed');
          toggleBtn.classList.remove('is-open');
          
          const lineHeight = parseFloat(window.getComputedStyle(descText).lineHeight) || 24;
          const threeLinesHeight = lineHeight * 3;
          descText.style.maxHeight = threeLinesHeight + 'px';
          descText.style.overflow = 'hidden';
          descText.style.display = '-webkit-box';
          descText.style.webkitLineClamp = '3';
          descText.style.webkitBoxOrient = 'vertical';
          if (textShow) textShow.classList.remove('hidden');
          if (textHide) textHide.classList.add('hidden');
        }
      }

      toggleBtn.addEventListener('click', toggleDescription);

      requestAnimationFrame(() => {
        checkIfNeedsToggle();
      });
    });
  }

  function initShareDropdown() {
    const shareButtons = document.querySelectorAll('.ec-product-share');
    
    shareButtons.forEach(shareButton => {
      const dropdown = shareButton.querySelector('.ec-product-share__dropdown');
      const shareOptions = dropdown.querySelectorAll('.ec-product-share__option');
      
      if (!shareButton || !dropdown) return;
      
      let isOpen = false;

      function getShareData() {
        const url = window.location.href;
        const title = document.querySelector('h1')?.textContent || document.title;
        return { url, title };
      }

      function toggleDropdown() {
        isOpen = !isOpen;
        if (isOpen) {
          shareButton.style.height = '100%';
          shareButton.style.borderRadius = '50px';
          shareButton.setAttribute('aria-expanded', 'true');
          dropdown.style.display = 'flex';
        } else {
          shareButton.style.height = '44px';
          shareButton.style.borderRadius = '50%';
          shareButton.setAttribute('aria-expanded', 'false');
          dropdown.style.display = 'none';
        }
      }

      shareButton.addEventListener('click', (e) => {
        e.stopPropagation();
        toggleDropdown();
      });

      document.addEventListener('click', (e) => {
        if (isOpen && !shareButton.contains(e.target)) {
          isOpen = false;
          shareButton.style.height = '44px';
          shareButton.style.borderRadius = '50%';
          shareButton.setAttribute('aria-expanded', 'false');
          dropdown.style.display = 'none';
        }
      });

      shareOptions.forEach(option => {
        option.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          const shareType = option.getAttribute('data-share');
          const linkHref = option.getAttribute('href');
          const useLinkHref = linkHref && linkHref !== '#';
          const { url, title } = getShareData();

          switch(shareType) {
            case 'facebook':
              window.open(useLinkHref ? linkHref : `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`, '_blank', 'width=600,height=400');
              break;
            case 'email':
              window.location.href = useLinkHref ? linkHref : `mailto:?subject=${encodeURIComponent(title)}&body=${encodeURIComponent(url)}`;
              break;
            case 'whatsapp':
              window.open(useLinkHref ? linkHref : `https://wa.me/?text=${encodeURIComponent(`${title} - ${url}`)}`, '_blank');
              break;
          }

          isOpen = false;
          shareButton.style.height = '44px';
          shareButton.style.borderRadius = '50%';
          shareButton.setAttribute('aria-expanded', 'false');
          dropdown.style.display = 'none';
        });
      });
    });
  }

  function updateStickyContent(sectionId) {
    const section = document.querySelector(`product-info[data-section="${sectionId}"]`);
    if (!section) return;
    
    const stickyImage = section.querySelector('.ec-product-info__buy-wrapper-sticky-image img');
    const stickyPrice = section.querySelector('#sticky-price-' + sectionId);

    const mainImage = section.querySelector('.ec-product-gallery__main-item--active img');
    if (mainImage && stickyImage) {
      const imageSrc = mainImage.src.replace(/(_\d+x\d+)?\.(jpg|jpeg|png|webp)/i, '_56x56.$2');
      stickyImage.src = imageSrc;
      stickyImage.alt = mainImage.alt;
    }

    const mainPriceEl = section.querySelector('#price-' + sectionId);
    if (mainPriceEl && stickyPrice) {
      const priceValues = mainPriceEl.querySelector('.ec-product-info__price-values');
      if (priceValues) {
        const comparePrice = priceValues.querySelector('.ec-product-info__price-compare');
        const currentPrice = priceValues.querySelector('.ec-product-info__price-current');
        
        let priceHTML = '';
        if (comparePrice) {
          priceHTML = `<span class="ec-product-info__buy-wrapper-sticky-price-compare">${comparePrice.innerHTML}</span>`;
        }
        if (currentPrice) {
          priceHTML += `<span class="ec-product-info__buy-wrapper-sticky-price-current">${currentPrice.innerHTML}</span>`;
        }
        stickyPrice.innerHTML = priceHTML;
      }
    }
  }

  function initStickyBuyWrapper() {
    const productInfoSections = document.querySelectorAll('product-info.ec-product-info');
    
    productInfoSections.forEach(section => {
      const buyWrapper = section.querySelector('.ec-product-info__buy-wrapper');
      const stickyTrigger = section.querySelector('.ec-product-info__sticky-trigger');
      const sectionId = section.dataset.section || section.id?.replace('MainProduct-', '');
      
      if (!buyWrapper || !stickyTrigger) return;

      const buyWrapperParent = buyWrapper.parentElement;
      if (!buyWrapperParent) return;

      function checkIfTriggerIsAboveViewport() {
        const rect = stickyTrigger.getBoundingClientRect();
        
        return rect.bottom < 0;
      }

      function checkInitialState() {
        if (checkIfTriggerIsAboveViewport()) {
          buyWrapperParent.classList.add('ec-product-info__buy-wrapper--sticky');
        } else {
          buyWrapperParent.classList.remove('ec-product-info__buy-wrapper--sticky');
        }
      }

      checkInitialState();

      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          
          const isAbove = checkIfTriggerIsAboveViewport();
          if (isAbove) {
            
            buyWrapperParent.classList.add('ec-product-info__buy-wrapper--sticky');
          } else {
            
            buyWrapperParent.classList.remove('ec-product-info__buy-wrapper--sticky');
          }
        });
      }, {
        threshold: 0, 
        rootMargin: '0px 0px -100px 0px' 
      });
      
      observer.observe(stickyTrigger);

      let ticking = false;
      function handleScroll() {
        if (!ticking) {
          window.requestAnimationFrame(() => {
            checkInitialState();
            ticking = false;
          });
          ticking = true;
        }
      }
      
      window.addEventListener('scroll', handleScroll, { passive: true });

      if (window.PUB_SUB_EVENTS && window.subscribe) {
        window.subscribe(window.PUB_SUB_EVENTS.variantChange, (event) => {
          if (event?.data?.sectionId === sectionId) {
            setTimeout(() => {
              updateStickyContent(sectionId);
            }, 50);
          }
        });
      }

      const mainPriceEl = section.querySelector('#price-' + sectionId);
      if (mainPriceEl) {
        const priceObserver = new MutationObserver(() => {
          updateStickyContent(sectionId);
        });
        priceObserver.observe(mainPriceEl, { childList: true, subtree: true });
      }

      const gallery = section.querySelector('.ec-product-gallery');
      if (gallery) {
        const imageObserver = new MutationObserver(() => {
          updateStickyContent(sectionId);
        });
        imageObserver.observe(gallery, { 
          childList: true, 
          subtree: true, 
          attributes: true,
          attributeFilter: ['class']
        });
      }
    });
  }

  function initCartErrorToast() {
    
    const toasts = document.querySelectorAll('.ec-product-info__toast');
    
    if (!toasts.length) {
      return;
    }

    function handleCartError(eventData) {
      if (!eventData) {
        return;
      }

      let toast = null;
      
      if (eventData.productVariantId) {
        const sectionId = findSectionIdByVariantId(eventData.productVariantId);
        if (sectionId) {
          toast = document.querySelector(`#ec-product-toast-${sectionId}`);
        }
      }

      if (!toast) {
        const allProductForms = document.querySelectorAll('product-form[data-section-id]');
        for (const productForm of allProductForms) {
          const sectionId = productForm.dataset.sectionId || productForm.getAttribute('data-section-id');
          if (sectionId) {
            const foundToast = document.querySelector(`#ec-product-toast-${sectionId}`);
            if (foundToast) {
              toast = foundToast;
              break;
            }
          }
        }
      }

      if (!toast && toasts.length > 0) {
        toast = toasts[0];
      }
      
      if (toast) {
        showToast(toast, eventData);
      }
    }

    function trySubscribe() {
      const subscribeFn = typeof subscribe !== 'undefined' ? subscribe : (typeof window !== 'undefined' && window.subscribe);
      const pubSubEvents = typeof PUB_SUB_EVENTS !== 'undefined' ? PUB_SUB_EVENTS : (typeof window !== 'undefined' && window.PUB_SUB_EVENTS);
      
      if (subscribeFn && pubSubEvents) {
        subscribeFn(pubSubEvents.cartError, (event) => {
          if (event && event.data) {
            handleCartError(event.data);
          } else if (event) {
            
            handleCartError(event);
          }
        });
        return true;
      }
      return false;
    }

    function interceptCartAdd() {
      const originalFetch = window.fetch;
      window.fetch = function(...args) {
        const url = args[0];

        if (typeof url === 'string' && url.includes('/cart/add')) {
          return originalFetch.apply(this, args)
            .then(response => {
              
              const clonedResponse = response.clone();

              if (response.status === 422 || response.status >= 400) {
                clonedResponse.json().then(data => {
                  if (data.status && data.message) {
                    handleCartError({
                      message: data.message,
                      description: data.description,
                      errors: data.errors || data.description
                    });
                  }
                }).catch(err => {
                  console.error('EC Main Product: Erro ao parsear resposta:', err);
                });
              }
              
              return response;
            });
        }
        
        return originalFetch.apply(this, args);
      };
    }

    if (!trySubscribe()) {
      interceptCartAdd();
    }
  }

  function findSectionIdByVariantId(variantId) {
    const variantInput = document.querySelector(`input.product-variant-id[value="${variantId}"]`);
    if (!variantInput) return null;
    
    const form = variantInput.closest('form');
    if (!form) return null;
    
    const productForm = form.closest('product-form');
    if (!productForm) return null;

    const sectionId = productForm.dataset.sectionId || productForm.getAttribute('data-section-id');
    if (sectionId) return sectionId;

    const section = productForm.closest('[id^="shopify-section-"]');
    if (section) {
      const sectionIdMatch = section.id.match(/shopify-section-(.+)/);
      if (sectionIdMatch) return sectionIdMatch[1];
    }
    
    return null;
  }

  function showToast(toastEl, errorData) {
    if (!toastEl) {
      return;
    }
    
    const messageEl = toastEl.querySelector('.ec-product-info__toast-message');
    if (!messageEl) {
      return;
    }

    let errorMessage = 'Não foi possível adicionar o produto ao carrinho.';
    
    if (errorData.message) {
      errorMessage = errorData.message;
    } else if (errorData.description) {
      errorMessage = errorData.description;
    } else if (errorData.errors) {
      if (typeof errorData.errors === 'string') {
        errorMessage = errorData.errors;
      } else if (Array.isArray(errorData.errors) && errorData.errors.length > 0) {
        errorMessage = errorData.errors[0];
      } else if (typeof errorData.errors === 'object') {
        const firstError = Object.values(errorData.errors)[0];
        errorMessage = Array.isArray(firstError) ? firstError[0] : firstError;
      }
    }
    
    messageEl.textContent = errorMessage;
    toastEl.hidden = false;
    toastEl.classList.add('ec-product-info__toast--show');

    setTimeout(() => {
      hideToast(toastEl);
    }, 5000);
  }

  function hideToast(toastEl) {
    if (!toastEl) return;
    toastEl.classList.remove('ec-product-info__toast--show');
    setTimeout(() => {
      toastEl.hidden = true;
    }, 300); 
  }

  function formatMoney(value) {
    return new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL'
    }).format(value);
  }

  function initBundle() {
    const bundleWrappers = document.querySelectorAll('[id^="bundle-"]');
    
    bundleWrappers.forEach(bundleWrapper => {
      const bundleItems = bundleWrapper.querySelectorAll('[data-bundle-item]');
      const bundleSummary = bundleWrapper.querySelector('[data-bundle-summary]');
      const buyButton = bundleWrapper.querySelector('[data-bundle-buy-button]');
      
      if (!bundleItems.length || !bundleSummary || !buyButton) return;
      
      initializeBundle(bundleItems, bundleSummary, buyButton);
    });
  }

  function initColorDropdown(dropdown, item, productId, allVariants, bundleProducts) {
    const button = dropdown.querySelector('[data-color-dropdown-button]');
    const menu = dropdown.querySelector('[data-color-dropdown-menu]');
    const selectedText = dropdown.querySelector('[data-color-dropdown-selected]');
    const hiddenRadios = dropdown.querySelectorAll('input[type="radio"]');
    
    if (!button || !menu || !selectedText || hiddenRadios.length === 0) return;

    const dropdownOptionPosition = hiddenRadios[0].name.match(/bundle-\d+-(\d+)/)?.[1];
    if (!dropdownOptionPosition) return;
    
    const dropdownItems = menu.querySelectorAll('.ec-bundle-item__color-dropdown-item');

    const closeDropdown = (e) => {
      if (!dropdown.contains(e.target)) {
        dropdown.setAttribute('data-open', 'false');
      }
    };
    document.addEventListener('click', closeDropdown);

    button.addEventListener('click', (e) => {
      e.stopPropagation();
      const isOpen = dropdown.getAttribute('data-open') === 'true';
      dropdown.setAttribute('data-open', isOpen ? 'false' : 'true');
    });

    dropdownItems.forEach((dropdownItem) => {
      dropdownItem.addEventListener('click', (e) => {
        e.stopPropagation();
        const variantId = dropdownItem.dataset.variantId;
        const optionValue = dropdownItem.dataset.optionValue;
        
        if (dropdownItem.disabled) return;

        const swatch = dropdownItem.querySelector('.ec-bundle-item__color-dropdown-swatch');
        const text = dropdownItem.querySelector('.ec-bundle-item__color-dropdown-text');

        selectedText.innerHTML = '';

        if (swatch) {
          const newSwatch = swatch.cloneNode(true);
          selectedText.appendChild(newSwatch);
        }

        const textSpan = document.createElement('span');
        textSpan.className = 'ec-bundle-item__color-dropdown-text';
        textSpan.textContent = optionValue;
        selectedText.appendChild(textSpan);

        const targetRadio = Array.from(hiddenRadios).find(r => r.value === variantId);
        if (targetRadio) {
          targetRadio.checked = true;
          
          targetRadio.dispatchEvent(new Event('change', { bubbles: true }));
        }

        dropdownItems.forEach(item => {
          item.classList.remove('ec-bundle-item__color-dropdown-item--selected');
        });
        dropdownItem.classList.add('ec-bundle-item__color-dropdown-item--selected');

        dropdown.setAttribute('data-open', 'false');
      });
    });

    const updateDropdownAvailability = () => {

      hiddenRadios.forEach((radio) => {
        const variantId = radio.value;
        const dropdownItem = Array.from(dropdownItems).find(item => item.dataset.variantId === variantId);
        
        if (dropdownItem) {
          
          dropdownItem.disabled = radio.disabled;
          if (radio.disabled) {
            dropdownItem.classList.add('ec-bundle-item__color-dropdown-item--disabled');
          } else {
            dropdownItem.classList.remove('ec-bundle-item__color-dropdown-item--disabled');
          }

          if (radio.checked) {
            dropdownItems.forEach(item => {
              item.classList.remove('ec-bundle-item__color-dropdown-item--selected');
            });
            dropdownItem.classList.add('ec-bundle-item__color-dropdown-item--selected');

            const swatch = dropdownItem.querySelector('.ec-bundle-item__color-dropdown-swatch');
            const text = dropdownItem.querySelector('.ec-bundle-item__color-dropdown-text');
            const optionValue = dropdownItem.dataset.optionValue;
            
            selectedText.innerHTML = '';
            if (swatch) {
              const newSwatch = swatch.cloneNode(true);
              selectedText.appendChild(newSwatch);
            }
            const textSpan = document.createElement('span');
            textSpan.className = 'ec-bundle-item__color-dropdown-text';
            textSpan.textContent = optionValue || text?.textContent || '';
            selectedText.appendChild(textSpan);
          }
        }
      });
    };

    hiddenRadios.forEach(radio => {
      radio.addEventListener('change', updateDropdownAvailability);
    });

    updateDropdownAvailability();

  }
  
  function initializeBundle(bundleItems, bundleSummary, buyButton) {
    if (!bundleItems.length || !bundleSummary || !buyButton) return;

      const mainProductForm = document.querySelector('product-form[data-section-id]');
      const mainProductId = mainProductForm?.closest('product-info')?.dataset?.productId;
      const sectionId = mainProductForm?.dataset?.sectionId || mainProductForm?.closest('product-info')?.dataset?.section;

      let currentMainVariantId = null;

      const getCurrentVariantId = () => {
        
        if (mainProductForm?.variantIdInput?.value) {
          return mainProductForm.variantIdInput.value;
        }

        if (sectionId) {
          const mainForm = document.querySelector(`#product-form-${sectionId}`);
          if (mainForm) {
            const variantInput = mainForm.querySelector('input[name="id"]');
            if (variantInput?.value) {
              return variantInput.value;
            }
          }
        }

        const anyProductForm = document.querySelector('product-form');
        if (anyProductForm?.variantIdInput?.value) {
          return anyProductForm.variantIdInput.value;
        }
        
        return null;
      };

      currentMainVariantId = getCurrentVariantId();

      const subscribeFn = typeof subscribe !== 'undefined' ? subscribe : (typeof window !== 'undefined' && window.subscribe);
      const pubSubEvents = typeof PUB_SUB_EVENTS !== 'undefined' ? PUB_SUB_EVENTS : (typeof window !== 'undefined' && window.PUB_SUB_EVENTS);
      
      if (pubSubEvents && subscribeFn) {
        subscribeFn(pubSubEvents.variantChange, (event) => {

          if (event?.data?.sectionId === sectionId && event?.data?.variant?.id) {
            currentMainVariantId = event.data.variant.id.toString();
            updateBundleSummary(); 
          }
        });
      }

      const bundleProducts = new Map();

      function getProductVariantsFromDOM(item, productId) {
        try {
          const scriptTag = item.querySelector(`script[data-bundle-variants="${productId}"]`);
          if (scriptTag && scriptTag.textContent) {
            const variants = JSON.parse(scriptTag.textContent);
            if (Array.isArray(variants)) {
              return variants;
            }
          }
        } catch (error) {
          console.error('Erro ao parsear variantes do DOM:', error);
        }
        return [];
      }

      function findFirstAvailableVariant(allVariants, selectedValues) {
        for (const variant of allVariants) {
          if (!variant.available) continue;
          
          let matches = true;
          if (selectedValues['1'] && variant.option1 !== selectedValues['1']) matches = false;
          if (selectedValues['2'] && variant.option2 !== selectedValues['2']) matches = false;
          if (selectedValues['3'] && variant.option3 !== selectedValues['3']) matches = false;
          
          if (matches) {
            return variant;
          }
        }
        return null;
      }

      function updateOptionAvailability(item, productId, allVariants) {
        if (!allVariants || allVariants.length === 0) return;
        
        const variantSelector = item.querySelector('.ec-bundle-item__variant-selector');
        if (!variantSelector) return;

        const optionGroups = variantSelector.querySelectorAll('.ec-bundle-item__option-group');
        const selectedValues = {}; 
        
        optionGroups.forEach((group) => {
          const radios = group.querySelectorAll('input[type="radio"]');
          const optionPosition = radios[0]?.name.match(/bundle-\d+-(\d+)/)?.[1];
          
          radios.forEach(radio => {
            if (radio.checked) {
              const variantId = radio.value;
              const variant = allVariants.find(v => v.id.toString() === variantId);
              if (variant && optionPosition) {
                if (optionPosition === '1') {
                  selectedValues['1'] = variant.option1;
                } else if (optionPosition === '2') {
                  selectedValues['2'] = variant.option2;
                } else if (optionPosition === '3') {
                  selectedValues['3'] = variant.option3;
                }
              }
            }
          });
        });

        optionGroups.forEach((group) => {
          const radios = group.querySelectorAll('input[type="radio"]');
          const optionPosition = radios[0]?.name.match(/bundle-\d+-(\d+)/)?.[1];
          
          radios.forEach(radio => {
            const variantId = radio.value;
            const variant = allVariants.find(v => v.id.toString() === variantId);
            
            if (!variant) {
              radio.disabled = true;
              return;
            }

            let optionValue = null;
            if (optionPosition === '1') {
              optionValue = variant.option1;
            } else if (optionPosition === '2') {
              optionValue = variant.option2;
            } else if (optionPosition === '3') {
              optionValue = variant.option3;
            }
            
            if (!optionValue) {
              radio.disabled = true;
              return;
            }

            let hasAvailableVariant = false;
            
            for (const testVariant of allVariants) {
              if (!testVariant.available) continue;

              let matchesThisOption = false;
              if (optionPosition === '1') {
                matchesThisOption = testVariant.option1 === optionValue;
              } else if (optionPosition === '2') {
                matchesThisOption = testVariant.option2 === optionValue;
              } else if (optionPosition === '3') {
                matchesThisOption = testVariant.option3 === optionValue;
              }
              
              if (!matchesThisOption) continue;

              let matchesOtherOptions = true;
              Object.keys(selectedValues).forEach(pos => {
                if (pos === optionPosition) return; 
                
                if (pos === '1') {
                  if (testVariant.option1 !== selectedValues['1']) matchesOtherOptions = false;
                } else if (pos === '2') {
                  if (testVariant.option2 !== selectedValues['2']) matchesOtherOptions = false;
                } else if (pos === '3') {
                  if (testVariant.option3 !== selectedValues['3']) matchesOtherOptions = false;
                }
              });
              
              if (matchesOtherOptions) {
                hasAvailableVariant = true;
                break;
              }
            }
            
            radio.disabled = !hasAvailableVariant;
          });
        });
      }

      bundleItems.forEach((item) => {
        const productId = item.dataset.productId;
        const variantId = item.dataset.variantId;
        const checkbox = item.querySelector('[data-bundle-checkbox]');
        const variantRadios = item.querySelectorAll('input[type="radio"][data-variant-id]');

        const allVariants = getProductVariantsFromDOM(item, productId);

        bundleProducts.set(productId, {
          element: item,
          variantId: variantId,
          selected: checkbox?.checked || false,
          price: 0,
          compareAtPrice: 0,
          variants: allVariants
        });

        if (allVariants.length > 0) {
          updateOptionAvailability(item, productId, allVariants);
        }

        const radioOptions = item.querySelectorAll('.ec-bundle-item__radio-option');
        radioOptions.forEach((radioOption) => {
          const radioInput = radioOption.querySelector('.ec-bundle-item__radio-input');
          if (radioInput) {
            
            if (radioInput.checked) {
              radioOption.classList.add('ec-bundle-item__radio-option--checked');
            }
            if (radioInput.disabled) {
              radioOption.classList.add('ec-bundle-item__radio-option--disabled');
            }

            const observer = new MutationObserver(() => {
              if (radioInput.disabled) {
                radioOption.classList.add('ec-bundle-item__radio-option--disabled');
              } else {
                radioOption.classList.remove('ec-bundle-item__radio-option--disabled');
              }
            });
            
            observer.observe(radioInput, {
              attributes: true,
              attributeFilter: ['disabled']
            });

            radioInput.addEventListener('change', () => {
              
              const name = radioInput.name;
              item.querySelectorAll(`input[name="${name}"]`).forEach((r) => {
                const option = r.closest('.ec-bundle-item__radio-option');
                if (option) {
                  option.classList.remove('ec-bundle-item__radio-option--checked');
                }
              });

              if (radioInput.checked) {
                radioOption.classList.add('ec-bundle-item__radio-option--checked');
              }
            });
          }
        });

        const colorDropdown = item.querySelector('[data-color-dropdown]');
        if (colorDropdown) {
          initColorDropdown(colorDropdown, item, productId, allVariants, bundleProducts);
        }

        if (checkbox) {
          checkbox.addEventListener('change', () => {
            updateBundleSummary();
          });
        }

        variantRadios.forEach(radio => {
          radio.addEventListener('change', () => {
            if (radio.checked) {
              const newVariantId = radio.value;
              const productData = bundleProducts.get(productId);
              
              if (productData && productData.variants) {
                
                const selectedVariant = productData.variants.find(v => v.id.toString() === newVariantId);
                
                if (selectedVariant) {
                  
                  const selectedValues = {};
                  const variantSelector = item.querySelector('.ec-bundle-item__variant-selector');
                  if (variantSelector) {
                    const optionGroups = variantSelector.querySelectorAll('.ec-bundle-item__option-group');
                    optionGroups.forEach((group) => {
                      const radios = group.querySelectorAll('input[type="radio"]');
                      const optionPosition = radios[0]?.name.match(/bundle-\d+-(\d+)/)?.[1];
                      const checkedRadio = Array.from(radios).find(r => r.checked);
                      
                      if (checkedRadio && optionPosition) {
                        const variantId = checkedRadio.value;
                        const variant = productData.variants.find(v => v.id.toString() === variantId);
                        if (variant) {
                          if (optionPosition === '1') {
                            selectedValues['1'] = variant.option1;
                          } else if (optionPosition === '2') {
                            selectedValues['2'] = variant.option2;
                          } else if (optionPosition === '3') {
                            selectedValues['3'] = variant.option3;
                          }
                        }
                      }
                    });
                  }

                  const firstAvailableVariant = findFirstAvailableVariant(productData.variants, selectedValues);
                  
                  if (firstAvailableVariant) {
                    
                    const variantSelector = item.querySelector('.ec-bundle-item__variant-selector');
                    if (variantSelector) {
                      const optionGroups = variantSelector.querySelectorAll('.ec-bundle-item__option-group');
                      optionGroups.forEach((group) => {
                        const radios = group.querySelectorAll('input[type="radio"]');
                        const optionPosition = radios[0]?.name.match(/bundle-\d+-(\d+)/)?.[1];

                        let targetValue = null;
                        if (optionPosition === '1') {
                          targetValue = firstAvailableVariant.option1;
                        } else if (optionPosition === '2') {
                          targetValue = firstAvailableVariant.option2;
                        } else if (optionPosition === '3') {
                          targetValue = firstAvailableVariant.option3;
                        }
                        
                        if (targetValue) {
                          
                          const matchingVariant = productData.variants.find(v => {
                            let matches = false;
                            if (optionPosition === '1' && v.option1 === targetValue) matches = true;
                            else if (optionPosition === '2' && v.option2 === targetValue) matches = true;
                            else if (optionPosition === '3' && v.option3 === targetValue) matches = true;

                            if (matches) {
                              if (selectedValues['1'] && v.option1 !== selectedValues['1'] && optionPosition !== '1') matches = false;
                              if (selectedValues['2'] && v.option2 !== selectedValues['2'] && optionPosition !== '2') matches = false;
                              if (selectedValues['3'] && v.option3 !== selectedValues['3'] && optionPosition !== '3') matches = false;
                            }
                            
                            return matches && v.available;
                          });
                          
                          if (matchingVariant) {
                            const targetRadio = Array.from(radios).find(r => r.value === matchingVariant.id.toString());
                            if (targetRadio && !targetRadio.checked) {
                              
                              targetRadio.setAttribute('checked', 'checked');
                              targetRadio.checked = true;
                            }
                          }
                        }
                      });
                    }

                    updateBundleItemVariant(item, productId, firstAvailableVariant.id.toString());
                  } else {
                    
                    updateBundleItemVariant(item, productId, newVariantId);
                  }

                  updateOptionAvailability(item, productId, productData.variants);
                } else {
                  updateBundleItemVariant(item, productId, newVariantId);
                }
              } else {
                updateBundleItemVariant(item, productId, newVariantId);
              }
              
              updateBundleSummary();
            }
          });
        });

        updateBundleItemPrice(item, variantId);
        updateBundleSummary();
      });

      function updateBundleItemVariant(item, productId, variantId) {
        const variantData = bundleProducts.get(productId);
        if (variantData) {
          variantData.variantId = variantId;
          updateBundleItemPrice(item, variantId);
        }

        const checkbox = item.querySelector('[data-bundle-checkbox]');
        if (checkbox) {
          checkbox.dataset.variantId = variantId;
        }
      }

      function updateBundleItemPrice(item, variantId) {
        const productId = item.dataset.productId;
        const variantData = bundleProducts.get(productId);
        if (!variantData) return;
        
        try {
          
          const allVariants = variantData.variants || [];
          const variant = allVariants.find(v => v.id.toString() === variantId.toString());
          
          if (variant) {
            variantData.price = variant.price / 100; 
            variantData.compareAtPrice = variant.compare_at_price ? variant.compare_at_price / 100 : 0;

            const priceEl = item.querySelector('[data-bundle-item-current-price]');
            const comparePriceEl = item.querySelector('[data-bundle-item-compare-price]');
            
            if (priceEl) {
              priceEl.textContent = formatMoney(variantData.price);
            }
            
            if (comparePriceEl) {
              if (variantData.compareAtPrice > variantData.price) {
                comparePriceEl.textContent = formatMoney(variantData.compareAtPrice);
                comparePriceEl.style.display = 'inline';
              } else {
                comparePriceEl.style.display = 'none';
              }
            }
          } else {
            
            const priceEl = item.querySelector('[data-bundle-item-current-price]');
            if (priceEl) {
              const priceText = priceEl.textContent.trim();
              const priceMatch = priceText.match(/[\d,]+\.?\d*/);
              if (priceMatch) {
                variantData.price = parseFloat(priceMatch[0].replace(/\./g, '').replace(',', '.'));
              }
            }
          }
        } catch (error) {
          console.error('Erro ao atualizar preço:', error);
          
          const priceEl = item.querySelector('[data-bundle-item-current-price]');
          if (priceEl) {
            const priceText = priceEl.textContent.trim();
            const priceMatch = priceText.match(/[\d,]+\.?\d*/);
            if (priceMatch) {
              variantData.price = parseFloat(priceMatch[0].replace(/\./g, '').replace(',', '.'));
            }
          }
        }
      }

      function extractPriceValue(priceText) {
        if (!priceText) return 0;
        
        const cleaned = priceText.replace(/[^\d,.]/g, '');
        
        if (cleaned.includes(',') && cleaned.includes('.')) {
          return parseFloat(cleaned.replace(/\./g, '').replace(',', '.'));
        }
        
        if (cleaned.includes(',')) {
          return parseFloat(cleaned.replace(',', '.'));
        }
        
        return parseFloat(cleaned) || 0;
      }

      function updateBundleSummary() {
        let totalPrice = 0;
        let totalComparePrice = 0;
        let selectedCount = 0;

        const mainPriceEl = document.querySelector('.ec-product-info__price-current strong');
        if (mainPriceEl) {
          const mainPriceText = mainPriceEl.textContent.trim();
          totalPrice += extractPriceValue(mainPriceText);

          const mainComparePriceEl = document.querySelector('.ec-product-info__price-compare');
          if (mainComparePriceEl && mainComparePriceEl.textContent.trim()) {
            const mainCompareText = mainComparePriceEl.textContent.trim();
            totalComparePrice += extractPriceValue(mainCompareText);
          } else {
            totalComparePrice += extractPriceValue(mainPriceText);
          }
        }

        bundleProducts.forEach((data, productId) => {
          const checkbox = data.element.querySelector('[data-bundle-checkbox]');
          if (checkbox && checkbox.checked) {
            selectedCount++;
            totalPrice += data.price;
            if (data.compareAtPrice > 0) {
              totalComparePrice += data.compareAtPrice;
            } else {
              totalComparePrice += data.price;
            }
          }
        });

        const totalPriceEl = bundleSummary.querySelector('[data-bundle-total-price]');
        const totalComparePriceEl = bundleSummary.querySelector('[data-bundle-total-compare]');
        const installmentsEl = bundleSummary.querySelector('[data-bundle-installments]');
        const summaryTextEl = bundleSummary.querySelector('.ec-bundle__summary-text p');
        
        if (totalPriceEl) {
          totalPriceEl.textContent = formatMoney(totalPrice);
        }
        
        if (totalComparePriceEl && totalComparePrice > totalPrice) {
          totalComparePriceEl.textContent = formatMoney(totalComparePrice);
          totalComparePriceEl.style.display = 'inline';
        } else if (totalComparePriceEl) {
          totalComparePriceEl.style.display = 'none';
        }
        
        if (summaryTextEl) {
          const totalItems = selectedCount + 1; 
          summaryTextEl.textContent = `Leve os ${totalItems} itens por:`;
        }
        
        if (installmentsEl) {
          
          const themeSettingsScript = document.querySelector('script[data-theme-settings]');
          let maxInstallments = 12;
          let minInstallmentValue = 50;
          
          if (themeSettingsScript) {
            try {
              const themeSettings = JSON.parse(themeSettingsScript.textContent);
              maxInstallments = themeSettings.card_max_installments || 12;
              minInstallmentValue = themeSettings.card_min_installment_value || 50;
            } catch (e) {
              console.error('Erro ao parsear configurações do tema:', e);
            }
          }

          let installmentCount = 0;
          let installmentValue = 0;
          const minInstallmentValueCents = minInstallmentValue * 100;
          
          if (totalPrice > 0) {
            for (let i = 1; i <= maxInstallments; i++) {
              const testValue = totalPrice / i;
              if (testValue >= minInstallmentValueCents) {
                installmentCount = i;
                installmentValue = testValue;
              } else {
                break;
              }
            }
          }
          
          if (installmentCount > 1) {
            installmentsEl.innerHTML = `em até <strong>${installmentCount}x</strong> de <strong>${formatMoney(installmentValue)}</strong> sem juros`;
          } else {
            installmentsEl.innerHTML = '';
          }
        }
      }

      if (buyButton) {
        buyButton.addEventListener('click', async () => {
          if (buyButton.disabled) return;
          
          buyButton.disabled = true;
          buyButton.textContent = 'Adicionando...';
          
          try {
            const itemsToAdd = [];

            let variantIdToAdd = currentMainVariantId;

            if (!variantIdToAdd) {
              variantIdToAdd = getCurrentVariantId();
            }
            
            if (variantIdToAdd) {
              itemsToAdd.push({
                id: variantIdToAdd,
                quantity: 1
              });
            } else {
              alert('Erro: Não foi possível identificar a variante selecionada. Por favor, tente novamente.');
              return;
            }

            bundleProducts.forEach((data, productId) => {
              const checkbox = data.element.querySelector('[data-bundle-checkbox]');
              if (checkbox && checkbox.checked && data.variantId) {
                itemsToAdd.push({
                  id: data.variantId,
                  quantity: 1
                });
              }
            });

            const cartDrawer = document.querySelector('cart-drawer');
            const cartNotification = document.querySelector('cart-notification');
            const cart = cartDrawer || cartNotification;

            let sectionsToRender = [];
            let sectionsUrl = window.location.pathname;
            
            if (cart && typeof cart.getSectionsToRender === 'function') {
              sectionsToRender = cart.getSectionsToRender().map((section) => section.id || section.section);
              if (typeof cart.setActiveElement === 'function') {
                cart.setActiveElement(document.activeElement);
              }
            }

            for (const item of itemsToAdd) {
              const formData = new FormData();
              formData.append('id', item.id);
              formData.append('quantity', item.quantity);
              
              const response = await fetch('/cart/add.js', {
                method: 'POST',
                body: formData
              });
              
              if (!response.ok) {
                const error = await response.json();
                throw new Error(error.description || 'Erro ao adicionar produto ao carrinho');
              }
            }

            if (sectionsToRender.length > 0 && cart) {
              const sectionsParam = sectionsToRender.join(',');
              const sectionsUrlParam = encodeURIComponent(sectionsUrl);

              const sectionsResponse = await fetch(`/cart?view=sections&sections=${sectionsParam}&sections_url=${sectionsUrlParam}`);
              
              if (sectionsResponse.ok) {
                const sectionsText = await sectionsResponse.text();
                let sectionsData = {};
                
                try {
                  sectionsData = JSON.parse(sectionsText);
                } catch (e) {
                  console.error('Erro ao parsear seções do carrinho:', e);
                }

                const cartResponse = await fetch('/cart.js');
                let cartData = {};
                
                if (cartResponse.ok) {
                  cartData = await cartResponse.json();
                }

                const fullCartData = {
                  ...cartData,
                  sections: sectionsData
                };

                if (typeof cart.renderContents === 'function') {
                  
                  if (cart.classList.contains('is-empty')) {
                    cart.classList.remove('is-empty');
                  }
                  cart.renderContents(fullCartData);
                }

                if (window.PUB_SUB_EVENTS && typeof publish !== 'undefined') {
                  publish(PUB_SUB_EVENTS.cartUpdate, {
                    source: 'bundle',
                    cartData: fullCartData
                  });
                }
                
                return; 
              }
            }

            if (cartDrawer) {
              
              const cartResponse = await fetch('/cart.js');
              if (cartResponse.ok) {
                const cartData = await cartResponse.json();

                if (window.PUB_SUB_EVENTS && typeof publish !== 'undefined') {
                  publish(PUB_SUB_EVENTS.cartUpdate, {
                    source: 'bundle',
                    cartData: cartData
                  });
                }
              }
              
              cartDrawer.open();
            } else if (cartNotification) {
              if (typeof cartNotification.renderContents === 'function') {
                cartNotification.renderContents();
              }
            } else {
              window.location.href = '/cart';
            }

            if (window.PUB_SUB_EVENTS && typeof publish !== 'undefined') {
              publish(PUB_SUB_EVENTS.cartUpdate, { source: 'bundle' });
            }
            
          } catch (error) {
            console.error('Erro ao adicionar kit ao carrinho:', error);
            alert('Erro ao adicionar produtos ao carrinho. Tente novamente.');
          } finally {
            buyButton.disabled = false;
            buyButton.textContent = 'Comprar kit';
          }
        });
      }

      updateBundleSummary();
  }

  function initVariantGallerySync() {
    const subscribeFn = typeof subscribe !== 'undefined' ? subscribe : (typeof window !== 'undefined' && window.subscribe);
    const pubSubEvents = typeof PUB_SUB_EVENTS !== 'undefined' ? PUB_SUB_EVENTS : (typeof window !== 'undefined' && window.PUB_SUB_EVENTS);

    if (!subscribeFn || !pubSubEvents) return;

    subscribeFn(pubSubEvents.variantChange, (event) => {
      const variant = event?.data?.variant;
      const sectionId = event?.data?.sectionId;
      if (!variant || !sectionId) return;

      const featuredMediaId = variant.featured_media?.id;
      if (!featuredMediaId) return;

      const gallery = document.querySelector(`#ECMediaGallery-${sectionId}`);
      if (!gallery) return;

      const targetMediaId = `${sectionId}-${featuredMediaId}`;

      const activeMain = gallery.querySelector('.ec-product-gallery__main-item--active');
      if (activeMain && activeMain.dataset.mediaId === targetMediaId) return;

      gallery.querySelectorAll('.ec-product-gallery__main-item').forEach((item) => {
        item.classList.toggle('ec-product-gallery__main-item--active', item.dataset.mediaId === targetMediaId);
      });

      gallery.querySelectorAll('.ec-product-gallery__thumbnail').forEach((thumb) => {
        const isActive = thumb.dataset.target === targetMediaId;
        thumb.classList.toggle('ec-product-gallery__thumbnail--active', isActive);
        thumb.setAttribute('aria-current', isActive ? 'true' : 'false');
      });

      const activeThumb = gallery.querySelector(`.ec-product-gallery__thumbnail[data-target="${targetMediaId}"]`);
      if (activeThumb) {
        activeThumb.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
      }
    });
  }
  
  function init() {
    initDescriptionToggle();
    initShareDropdown();
    initStickyBuyWrapper();
    initShippingCalculator();
    initCartErrorToast();
    initBundle();
    initVariantGallerySync();
  }

  function initShippingCalculator() {
    const calculators = document.querySelectorAll('[data-shipping-calculator]');
    
    calculators.forEach(calculator => {
      const sectionId = calculator.dataset.shippingCalculator;
      const input = calculator.querySelector('.ec-shipping-calculator__input');
      const calculateBtn = calculator.querySelector('[data-shipping-calculate-btn]');
      const messageEl = calculator.querySelector('[data-shipping-message]');
      const resultsEl = calculator.querySelector('[data-shipping-results]');
      const resultsListEl = calculator.querySelector('[data-shipping-results-list]');
      
      if (!input || !calculateBtn || !messageEl || !resultsEl || !resultsListEl) return;

      input.addEventListener('input', function(e) {
        let value = e.target.value.replace(/\D/g, '');
        if (value.length > 5) {
          value = value.substring(0, 5) + '-' + value.substring(5, 8);
        }
        e.target.value = value;
      });

      input.addEventListener('keypress', function(e) {
        if (e.key === 'Enter') {
          e.preventDefault();
          calculateBtn.click();
        }
      });

      calculateBtn.addEventListener('click', async function() {
        const cep = input.value.replace(/\D/g, '');

        if (cep.length !== 8) {
          showMessage(messageEl, 'Por favor, digite um CEP válido', 'error');
          return;
        }

        calculateBtn.disabled = true;
        showMessage(messageEl, 'Calculando frete...', 'loading');
        resultsEl.style.display = 'none';
        
        try {
          
          const addressData = await fetchAddressByCEP(cep);
          
          if (!addressData || addressData.erro) {
            showMessage(messageEl, 'CEP não encontrado. Por favor, verifique o CEP digitado.', 'error');
            calculateBtn.disabled = false;
            return;
          }

          const shippingOptions = await calculateShipping(cep, sectionId);
          
          if (!shippingOptions || shippingOptions.length === 0) {
            showMessage(messageEl, 'Não encontramos opções de frete para este CEP.', 'error');
            calculateBtn.disabled = false;
            return;
          }

          displayShippingResults(resultsListEl, shippingOptions);
          showMessage(messageEl, '', '');
          resultsEl.style.display = 'block';
          
        } catch (error) {
          console.error('Erro ao calcular frete:', error);
          showMessage(messageEl, 'Erro ao calcular frete. Tente novamente.', 'error');
        } finally {
          calculateBtn.disabled = false;
        }
      });
    });
  }

  async function fetchAddressByCEP(cep) {
    try {
      const response = await fetch(`https://viacep.com.br/ws/${cep}/json/`);
      if (!response.ok) throw new Error('Erro ao buscar CEP');
      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Erro ao buscar CEP:', error);
      return null;
    }
  }

  async function calculateShipping(cep, sectionId) {
    try {
      const zipCode = cep.replace(/\D/g, '');
      
      if (zipCode.length !== 8) {
        throw new Error('CEP inválido');
      }

      const addressData = await fetchAddressByCEP(zipCode);
      
      if (!addressData || addressData.erro || !addressData.uf) {
        throw new Error('CEP não encontrado');
      }

      const province = addressData.uf;
      const city = addressData.localidade || '';
      const streetName = addressData.logradouro || '';
      const neighborhood = addressData.bairro || '';

      const wordJoiner = '\u2060';
      const concatenatedAddress1 = streetName ? `${streetName}${wordJoiner}` : '';
      const concatenatedAddress2 = neighborhood ? `${wordJoiner}${neighborhood}` : '';

      const formattedZip = zipCode.slice(0, 5) + '-' + zipCode.slice(5);

      const productInfo = document.querySelector(`product-info[data-section="${sectionId}"]`);
      const currentVariantId = productInfo?.querySelector('input[name="id"]')?.value;
      
      let itemKey = null;
      let needsCleanup = false;

      if (currentVariantId) {
        const cartResponse = await fetch('/cart.js');
        const cart = await cartResponse.json();
        
        const existingItem = cart.items.find(item => item.variant_id.toString() === currentVariantId.toString());
        
        if (!existingItem) {
          const addResponse = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              id: currentVariantId,
              quantity: 1
            })
          });
          
          if (addResponse.ok) {
            const updatedCart = await fetch('/cart.js').then(r => r.json());
            const newItem = updatedCart.items.find(item => item.variant_id.toString() === currentVariantId.toString());
            if (newItem) {
              itemKey = newItem.key;
              needsCleanup = true;
            }
          }
        }
      }

      const addressDataForCart = {
        name: "",
        lastName: "",
        address1: concatenatedAddress1,
        streetName: streetName,
        streetNumber: "",
        address2: concatenatedAddress2,
        line2: "",
        neighborhood: neighborhood,
        city: city,
        zoneCode: province,
        postalCode: formattedZip,
        countryCode: "BR",
        oneTimeUse: false
      };

      await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          attributes: {
            _shipping_address: JSON.stringify(addressDataForCart)
          }
        })
      });

      const shippingUrl = `/cart/shipping_rates.json?` +
        `shipping_address[zip]=${encodeURIComponent(formattedZip)}` +
        `&shipping_address[country]=BR` +
        `&shipping_address[province]=${encodeURIComponent(province)}` +
        `&shipping_address[city]=${encodeURIComponent(city)}` +
        `&shipping_address[address1]=${encodeURIComponent(concatenatedAddress1)}` +
        `&shipping_address[address2]=${encodeURIComponent(concatenatedAddress2)}` +
        `&shipping_address[street_name]=${encodeURIComponent(streetName)}` +
        `&shipping_address[neighborhood]=${encodeURIComponent(neighborhood)}`;

      const response = await fetch(shippingUrl);
      
      if (!response.ok) {
        throw new Error('Erro ao buscar opções de frete');
      }

      const shippingData = await response.json();

      if (needsCleanup && itemKey) {
        await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: itemKey,
            quantity: 0
          })
        });
      }

      if (!shippingData.shipping_rates || shippingData.shipping_rates.length === 0) {
        return [];
      }

      const shippingOptions = shippingData.shipping_rates.map(rate => {
        const price = parseFloat(rate.price) || 0;
        const priceInCents = Math.round(price * 100);
        
        let timeText = 'Prazo a confirmar';
        
        const extractDaysFromName = (name) => {
          if (!name) return null;
          const match = name.match(/(\d+)\s*dias?\s*úteis?/i);
          return match ? parseInt(match[1], 10) : null;
        };

        const extractDaysFromDescription = (description) => {
          if (!description) return null;
          const match = description.match(/(\d+)\s*dias?\s*úteis?/i);
          return match ? parseInt(match[1], 10) : null;
        };

        if (rate.delivery_days && Array.isArray(rate.delivery_days) && rate.delivery_days.length > 0) {
          const minDays = rate.delivery_days[0] || 0;
          const maxDays = rate.delivery_days[1] || minDays;
          
          if (minDays === maxDays && minDays > 0) {
            timeText = `${minDays} dia${minDays !== 1 ? 's' : ''} útil${minDays !== 1 ? 'eis' : ''}`;
          } else if (minDays > 0) {
            timeText = `${minDays} a ${maxDays} dias úteis`;
          }
        } else if (rate.delivery_range) {
          if (rate.delivery_range.min && rate.delivery_range.max) {
            const minDate = new Date(rate.delivery_range.min);
            const maxDate = new Date(rate.delivery_range.max);
            const today = new Date();
            today.setHours(0, 0, 0, 0);
            
            const diffTime = maxDate - today;
            const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
            
            if (diffDays > 0) {
              timeText = `Em até ${diffDays} dia${diffDays !== 1 ? 's' : ''} útil${diffDays !== 1 ? 'eis' : ''}`;
            }
          }
        } else if (rate.delivery_date) {
          const deliveryDate = new Date(rate.delivery_date);
          const today = new Date();
          today.setHours(0, 0, 0, 0);
          
          const diffTime = deliveryDate - today;
          const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
          
          if (diffDays > 0) {
            timeText = `Em até ${diffDays} dia${diffDays !== 1 ? 's' : ''} útil${diffDays !== 1 ? 'eis' : ''}`;
          }
        } else {
          const daysFromName = extractDaysFromName(rate.name);
          const daysFromDescription = extractDaysFromDescription(rate.description);
          const days = daysFromName || daysFromDescription;
          
          if (days && days > 0) {
            timeText = `${days} dia${days !== 1 ? 's' : ''} útil${days !== 1 ? 'eis' : ''}`;
          }
        }

        const name = rate.name || rate.description || 'Frete';
        const description = rate.description || '';

        return {
          name: name,
          time: timeText,
          price: priceInCents,
          available: true
        };
      });

      return shippingOptions;
    } catch (error) {
      throw error;
    }
  }

  function displayShippingResults(resultsListEl, shippingOptions) {
    
    resultsListEl.innerHTML = '';

    shippingOptions.forEach((option, index) => {
      const optionEl = document.createElement('div');
      optionEl.className = `ec-shipping-option ${option.price === 0 ? 'ec-shipping-option--free' : ''} ${!option.available ? 'ec-shipping-option--unavailable' : ''}`;
      
      const priceText = option.price === 0 
        ? 'Grátis' 
        : new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(option.price / 100);
      
      optionEl.innerHTML = `
        <span class="ec-shipping-option__name">${option.name}</span>
        <span class="ec-shipping-option__time">Prazo estimado: ${option.time}</span>
        <span class="ec-shipping-option__price">${priceText}</span>
      `;
      
      resultsListEl.appendChild(optionEl);

      if (index < shippingOptions.length - 1) {
        const divider = document.createElement('div');
        divider.className = 'ec-shipping-option__divider';
        resultsListEl.appendChild(divider);
      }
    });
  }

  function showMessage(messageEl, text, type) {
    if (!messageEl) return;
    
    messageEl.textContent = text;
    messageEl.className = 'ec-shipping-calculator__message';
    
    if (type) {
      messageEl.classList.add(`ec-shipping-calculator__message--${type}`);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
